/**
 * TimelineHeaderNowLine Component
 *
 * Renders the "NOW" date indicator in the header as SVG elements.
 * Must be rendered inside the main header <svg> so it inherits the zoom
 * CSS scaleX transform and stays in sync during zoom animations.
 */

import React from 'react'
import { useTimelineStyles } from '../../../hooks/use-timeline-styles'

const BADGE_WIDTH = 50
const BADGE_HEIGHT = 16

/**
 * TimelineHeaderNowLine - NOW date indicator in header (SVG)
 *
 * @param {Object} props
 * @param {number} props.x - X position in SVG coordinate space
 * @param {string} props.dateString - Formatted date string (e.g., "Feb 10")
 */
export const TimelineHeaderNowLine = ({ x, dateString }) => {
  const { TimelineStyles } = useTimelineStyles()

  return (
    <>
      {/* Vertical line — rendered first so badge sits on top */}
      <line
        x1={x}
        y1={0}
        x2={x}
        y2="100%"
        stroke={TimelineStyles.now.fillColor}
        strokeWidth={TimelineStyles.now.width}
        opacity={0.6}
        pointerEvents="none"
      />
      {/* Badge background */}
      <rect
        x={x - BADGE_WIDTH / 2}
        y={0}
        width={BADGE_WIDTH}
        height={BADGE_HEIGHT}
        fill={TimelineStyles.now.fillColor}
        rx={4}
        pointerEvents="none"
      />
      {/* Badge text */}
      <text
        x={x}
        y={BADGE_HEIGHT / 2}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={9}
        fontWeight="bold"
        fill={TimelineStyles.now.textColor}
        style={{ fontFamily: 'inherit' }}
        pointerEvents="none"
      >
        {dateString}
      </text>
    </>
  )
}
